import { CCliente } from "./cliente.model";

export class RespuestaFormulario{
    tipo_pregunta:number=0;
    codigo_pregunta:string='';
    binaria?:number;
    opcion_seleccionada?:string;
    satisfaccion?:number;
    comentario?:string;
    cliente?:CCliente;   
}